(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pdp_complementary-products"] && !Shopify.designMode) return;
  try {
    class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              let event = new Event('recommendations-loaded', { bubbles: true });
              document.body.dispatchEvent(event);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  // Toggle visibility of "Add All" buttons based on whether recommendations have loaded
  if (!window.__bindAddAllComplementaryToggle) {
    window.__bindAddAllComplementaryToggle = true;

    const toggleAddAllButtons = () => {
      document.querySelectorAll('add-all-complementary[data-recommendations-wrapper]').forEach((btn) => {
        const wrapperId = btn.dataset.recommendationsWrapper;
        const recEl = wrapperId
          ? document.querySelector(`product-recommendations[data-recommendations-wrapper="${wrapperId}"]`)
          : null;

        const hasRecs = !!recEl?.querySelector('swiper-slide[data-variant-id]');
        btn.toggleAttribute('hidden', !hasRecs);
      });
    };

    document.body.addEventListener('recommendations-loaded', toggleAddAllButtons);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', toggleAddAllButtons);
    } else {
      toggleAddAllButtons();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
